/**
 * Pagination component for filtering entries.
 * @param {number} initialPage - The initial page number.
 * @param {number} perPageDesktop - Number of entries per page on desktop.
 * @param {number} perPageMobile - Number of entries per page on mobile.
 * @returns {object} The pagination component.
 */
export default function pagination(
	initialPage = 1,
	perPageDesktop = 12,
	perPageMobile = 6,
) {
	return {
		currentPage: initialPage,
		perPage: perPageDesktop,
		totalPages: 0,
		perPageMobile: perPageMobile,
		perPageDesktop: perPageDesktop,
		desktopBreakpoint: 1024,

		updatePerPage() {
			const isDesktop = window.matchMedia(
				`(min-width: ${this.desktopBreakpoint}px)`,
			).matches;
			const newPerPage = isDesktop
				? this.perPageDesktop
				: this.perPageMobile;

			if (newPerPage !== this.perPage) {
				const firstItemIndex = (this.currentPage - 1) * this.perPage;
				this.perPage = newPerPage;
				this.currentPage =
					Math.floor(firstItemIndex / this.perPage) + 1;
				return true; // Return true if changed
			}
			return false;
		},
	};
}
